module.exports = __webpack_public_path__ + "static/media/servicedesignbtm.3c12c088.svg";